import { RootProvider } from '@revolut-internal/ui-kit'
import { createContext, FC, PropsWithChildren } from 'react'

import { useTopNavConfig } from 'containers/Sidebar'

import { useLayoutProvider } from './hooks/useLayoutProvider'

export const LayoutContext = createContext<
  ReturnType<typeof useLayoutProvider> | undefined
>(undefined)

export const LayoutProvider: FC<PropsWithChildren> = props => {
  const value = useLayoutProvider()
  const topNav = useTopNavConfig(value)

  return (
    <LayoutContext.Provider value={value}>
      <RootProvider mode={value.themeMode} topNav={topNav}>
        {props.children}
      </RootProvider>
    </LayoutContext.Provider>
  )
}
